// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    //apiUrl: 'http://localhost:8080',
    apiUrl: 'https://ams-dev.technologicalife.it/api',
    firebase: {
        apiKey: "AIzaSyCXHlNVcAEGpot3Asq1VxCx4Lxt7lEHupg",
        authDomain: "ams-roadside-dev.firebaseapp.com",
        projectId: "ams-roadside-dev",
        storageBucket: "ams-roadside-dev.firebasestorage.app",
        messagingSenderId: "654790393618",
        appId: "1:654790393618:web:0a99981b9e4338c6517dcb",
        measurementId: "G-MPFZEEL4DX"
    },
    uploadMaxFileSize: 20 * 1024 * 1024,
    currentUserRefreshSeconds : 60
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
